"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const errors_1 = require("@ledgerhq/errors");
const currencies_1 = require("../../currencies");
const account_1 = require("../../account");
const constants_1 = require("./constants");
const logic_1 = require("./logic");
const errors_2 = require("./errors");
const getTransactionStatus = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const errors = {};
    const warnings = {};
    if (!t.recipient) {
        errors.recipient = new errors_1.RecipientRequired();
    }
    else if ((0, logic_1.isSelfTransaction)(a, t)) {
        errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
    }
    else if (!(0, logic_1.isValidAddress)(t.recipient)) {
        errors.recipient = new errors_1.InvalidAddress("", {
            currencyName: a.currency.name,
        });
    }
    if (!t.fees) {
        errors.fees = new errors_1.FeeNotLoaded();
    }
    if (!errors.amount &&
        t.amount.eq(0) &&
        !t.useAllAmount &&
        !["unDelegate", "withdraw", "reDelegateRewards", "claimRewards"].includes(t.mode)) {
        errors.amount = new errors_1.AmountRequired();
    }
    let totalSpent = new bignumber_js_1.default(0); // Will be in token amount for token transacations
    let totalSpentEgld = new bignumber_js_1.default(0); // Amount spent in main currency (EGLD)
    const tokenAccount = (t.subAccountId && a.subAccounts && a.subAccounts.find(ta => ta.id === t.subAccountId)) || null;
    if (tokenAccount) {
        totalSpent = t.amount;
        totalSpentEgld = t.fees || new bignumber_js_1.default(0);
        if (!errors.amount && t.amount.gt(tokenAccount.balance)) {
            errors.amount = new errors_1.NotEnoughBalance();
        }
        if (!errors.amount && !totalSpentEgld.decimalPlaces(constants_1.DECIMALS_LIMIT).isEqualTo(totalSpentEgld)) {
            errors.amount = new errors_2.ElrondDecimalsLimitReached();
        }
    }
    else {
        totalSpent = totalSpentEgld = (0, logic_1.isAmountSpentFromBalance)(t.mode)
            ? ((_a = t.fees) === null || _a === void 0 ? void 0 : _a.plus(t.amount)) || t.amount
            : t.fees || new bignumber_js_1.default(0);
        if (t.mode === "send" && t.fees && t.amount.div(10).lt(t.fees)) {
            warnings.feeTooHigh = new errors_1.FeeTooHigh();
        }
        // All delegate and undelegate transactions must have an amount >= 1 EGLD
        if (!errors.amount && t.amount.lt(constants_1.MIN_DELEGATION_AMOUNT)) {
            const formattedAmount = (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(a), constants_1.MIN_DELEGATION_AMOUNT, {
                showCode: true,
            });
            if (t.mode === "delegate") {
                errors.amount = new errors_2.ElrondMinDelegatedAmountError("", {
                    formattedAmount,
                });
            }
            else if (t.mode === "unDelegate") {
                errors.amount = new errors_2.ElrondMinUndelegatedAmountError("", {
                    formattedAmount,
                });
            }
        }
        // When undelegating, unless undelegating all, the delegation must remain >= 1 EGLD
        const delegationBalance = (_b = a.elrondResources.delegations.find(d => d.contract === t.recipient)) === null || _b === void 0 ? void 0 : _b.userActiveStake;
        const delegationRemainingBalance = new bignumber_js_1.default(delegationBalance || 0).minus(t.amount);
        const delegationBalanceForbidden = delegationRemainingBalance.gt(0) && delegationRemainingBalance.lt(constants_1.MIN_DELEGATION_AMOUNT);
        if (!errors.amount && t.mode === "unDelegate" && delegationBalanceForbidden) {
            const formattedAmount = (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(a), constants_1.MIN_DELEGATION_AMOUNT, {
                showCode: true,
            });
            errors.amount = new errors_2.ElrondDelegationBelowMinimumError("", {
                formattedAmount,
            });
        }
    }
    if (!errors.amount && totalSpentEgld.gt(a.spendableBalance)) {
        errors.amount =
            tokenAccount || !["delegate", "send"].includes(t.mode)
                ? new errors_2.NotEnoughEGLDForFees()
                : new errors_1.NotEnoughBalance();
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees: t.fees || new bignumber_js_1.default(0),
        amount: t.amount,
        totalSpent,
    });
});
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map